import { useMutation } from 'react-query';

import * as Api from '../api';

const useDownload = () => useMutation(async ({ uuid }) => Api.Download({ uuid }));

export default useDownload;
